// payload: auth_token
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'

// payload: { payload: quote }
export const LOAD_QUOTE = 'LOAD_QUOTE'

// payload: --not set--
export const SET_QUOTE_LOADED = 'SET_QUOTE_LOADED'

// payload: { payload: payload }
export const UPDATE_QUOTE = 'UPDATE_QUOTE'

// payload: --not set--
export const SET_QUOTE_SAVED = 'SET_QUOTE_SAVED'

// payload: { rate, pmRatio, showHosting }
export const UPDATE_QUOTE_PARAMS = 'UPDATE_QUOTE_PARAMS'

// payload: optionalRate
export const UPDATE_OPTIONAL_RATE = 'UPDATE_OPTIONAL_RATE'

// payload: { quoteTemplates }
export const SET_QUOTE_TEMPLATES = 'SET_QUOTE_TEMPLATES'

// payload: { project_id, job_no, customer, title }
export const SET_QUOTE_META = 'SET_QUOTE_META'

// payload: { type, message }
export const SET_FLASH = 'SET_FLASH'

// payload: -- not set --
export const CLEAR_FLASH = 'CLEAR_FLASH'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js